import React, { Component } from 'react';
import Immutable from 'immutable';
import { Router, Route } from 'react-router';
import {isTouchDevice} from '../utils/Browser';
import _extends from 'object-assign';

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function isLeftClickEvent(event) {
    return event.button === 0;
}

function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function isEmptyObject(object) {
    for (var p in object) {
        if (object.hasOwnProperty(p)) return false;
    }return true;
}

// More or less copied out of React Router's Link.
const LinkTR = React.createClass({
    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    propTypes: {
        to: React.PropTypes.string.isRequired,
        query: React.PropTypes.object,
        hash: React.PropTypes.string,
        state: React.PropTypes.object,
        activeStyle: React.PropTypes.object,
        activeClassName: React.PropTypes.string,
        onlyActiveOnIndex: React.PropTypes.bool.isRequired,
        onClick: React.PropTypes.func
    },

    getDefaultProps() {
        return {
            onlyActiveOnIndex: false,
            className: '',
            style: {
                cursor: 'pointer'
            }
        };
    },

    handleClick(event) {
        var allowTransition = true;

        if (this.props.onClick) this.props.onClick(event);

        if (event.type == 'click') {
            if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
        }

        if (event.defaultPrevented === true) allowTransition = false;

        // If target prop is set (e.g. to "_blank") let browser handle link.
        /* istanbul ignore if: untestable with Karma */
        if (this.props.target) {
            if (!allowTransition) event.preventDefault();

            return;
        }

        event.preventDefault();

        if (allowTransition) {
            var _props = this.props;
            var state = _props.state;
            var to = _props.to;
            var query = _props.query;
            var hash = _props.hash;

            if (hash) to += hash;

            this.context.history.pushState(state, to, query);
        }
    },

    render() {
        var _props2 = this.props;
        var to = _props2.to;
        var query = _props2.query;
        var hash = _props2.hash;
        var state = _props2.state;
        var activeClassName = _props2.activeClassName;
        var activeStyle = _props2.activeStyle;
        var onlyActiveOnIndex = _props2.onlyActiveOnIndex;

        var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

        // Manually override onClick.
        if (isTouchDevice()) {
            props.onTouchTap = this.handleClick;
        } else {
            props.onClick = this.handleClick;
        }

        // Ignore if rendered outside the context of history, simplifies unit testing.
        var history = this.context.history;

        if (history) {
            //props.href = history.createHref(to, query);

            if (hash) props.href += hash;

            if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
                if (history.isActive(to, query, onlyActiveOnIndex)) {
                    if (activeClassName) props.className += props.className === '' ? activeClassName : ' ' + activeClassName;

                    if (activeStyle) props.style = _extends({}, props.style, activeStyle);
                }
            }
        }

        return React.createElement('tr', props, this.props.children);
    }
});

export default LinkTR;



/** WEBPACK FOOTER **
 ** ./src/components/LinkTR.js
 **/